import _ from 'lodash';

import { canUseDOM } from '../../../helpers/dom';
import * as Layouts from '../../editing/metadata/layout';
import * as Modules from '../../editing/metadata/modules';
import * as Sections from '../../editing/metadata/sections';
import { transformEntity } from '../../helpers/content';

export const migrateObject = (savedObject, meta, key) => {
  if (meta?.migrator) {
    const logMigrations = process.env.NODE_ENV === 'development' && canUseDOM();
    // migrators mutate savedObject, so the before copy is only available here
    const before = logMigrations ? _.cloneDeep(savedObject) : null;
    const migratedData = meta.migrator(key ? savedObject[key] : savedObject);
    const output = key ? _.merge({}, savedObject, { [key]: migratedData }) : migratedData;
    if (logMigrations) console.debug('migrateObject', before, output);
    return output;
  }
  return savedObject;
};

const hierarchicalContentDataMigration = contents =>
  transformEntity(contents, item => {
    if (item?.component) {
      if (item.component === 'Section') {
        // TODO - other section types
        return migrateObject(item, Sections[item.component], null);
      }
      return migrateObject(item, Modules[item.component], null);
    }
    if (item?.type) {
      if (item.type === 'Section') {
        // TODO - other section types
        return migrateObject(item, Sections[item.type], 'data');
      }
      return migrateObject(item, Modules[item.type], 'data');
    }
    return item;
  });

const migrateLayoutModules = modules =>
  Object.fromEntries(Object.entries(modules || {}).map(([k, v]) => [k, migrateObject(v, Modules[k], null)]));

const metaDataMigration = metadata => {
  const newMetadata = _.cloneDeep(metadata);

  if (newMetadata) {
    newMetadata.layouts = Object.fromEntries(
      Object.entries(newMetadata.layouts || {}).map(([k, v]) => [
        k,
        { ...migrateObject(v, Layouts[k], null), modules: migrateLayoutModules(v.modules) },
      ])
    );
  }

  return newMetadata;
};

export default function migrate_content(content) {
  content = content || {};
  content.contents = content.contents || {};

  if (content.contentType === 'Cms::Content::BusinessService') {
    // skip migrating BusinessService via old module migrations
    return content;
  }

  if (content.contentType === 'Cms::Content::Page') {
    content.metadata = metaDataMigration(content.metadata);
  }

  content.contents = hierarchicalContentDataMigration(content.contents);

  return content;
}
